module.exports = __webpack_public_path__ + "img/braintree.9c27686f.png";